var _path, _circle, _ellipse, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRtContactSupportIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66683 2H7.33349C4.01979 2 1.3335 4.68629 1.3335 8V11.3333C1.3335 12.8061 2.5274 14 4.00016 14H8.66683C11.9805 14 14.6668 11.3137 14.6668 8C14.6668 4.68629 11.9805 2 8.66683 2Z",
    stroke: "#181D27",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00016,
    cy: 7.99967,
    r: 0.666667,
    fill: "#181D27"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.6667,
    cy: 7.99967,
    rx: 0.666667,
    ry: 0.666667,
    fill: "#181D27"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.33317,
    cy: 7.99967,
    r: 0.666667,
    fill: "#181D27"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRtContactSupportIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RT_contactSupport_icon.e3c25d5b73947342e4165c5b1f71908b.svg";